
import { Provide, Mixins } from 'vue-property-decorator';
import StudentsWithFinishedLiveCourses from './StudentsWithFinishedLiveCourses.vue';

export default class StudentsWithAiCourses extends Mixins(StudentsWithFinishedLiveCourses) {
    @Provide() public type: string = 'ai';
}
